import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found" className="container-nc py-32 text-center">
      <p className="overline mb-4">Page not found</p>
      <h1 className="font-serif text-6xl md:text-7xl text-espresso">404</h1>
      <p className="text-muted_brown mt-4">The page you're looking for doesn't exist.</p>
      <Link to="/" className="btn-primary mt-8 inline-flex">Back to Home</Link>
    </div>
  );
}
